import { allImages } from "../../services/images";
import { useNavigate } from "react-router-dom";
import { SubServices, Blog } from "../../models/models";
import { useState, useEffect } from "react";
import { useAppSelector } from "../../Redux/hook";
import SvgIcon from "../../assets/dotted.jsx";
import { MdStar } from "react-icons/md";
import { IoArrowBackOutline } from "react-icons/io5";
import { FaArrowDown } from "react-icons/fa";
import { TbArrowBigDownLinesFilled } from "react-icons/tb";
import { TbArrowBigDown } from "react-icons/tb";
import './reusable.scss';
var links = [
    { name: "Home", path: "/" },
    {
        name: "About Us", path: "/aboutus", submenu: [
            { name: "About Us", path: "/aboutus" },
            { name: "CSR", path: "/csr" },
            { name: "Strengths", path: "/strength" },
            { name: "Announcements", path: "/announcements" },
            { name: "AGM Notice", path: "/agmnotice", link: allImages.agmNotice },
            { name: "Annual Returns", path: "/annualreturns", link: allImages.annualnotice },
            { name: "CSR Financial Year 2025-26", path: "/cs256", link: allImages.cs2526 },
            { name: "Brochure", path: "/brochure" ,link: allImages.brochure},
            { name: "Workshop", path: "/workshop" },
        ]
    },
    { name: "Services", path: "/services" },
    { name: "Equipment", path: "/equipments" },
    {
        name: "Clients", path: "/clients", submenu: [
            {name: "Clients", path: "/clients"},
            { name: "Testimonials", path: "/#Testimonials" }
        ]
    },
    { name: "Gallery", path: "/gallery" },
    { name: "Projects", path: "/ourprojects" },
    { name: "Careers", path: "https://jobs.pbltransport.co.in/jobs/Careers" }
]
function PhotoFrame({ image = "", fWidth = '425px', fHeight = '300px', width = 350, height = 245 }) {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    return (
        <div>
            <div className='photoFrame' style={{ width: fWidth, height: fHeight }}>
                <div className='border1' style={{ borderTop: `2px solid ${!lightMode ? "#88E9F9" : "#085D6B"}`, borderLeft: `2px solid ${!lightMode ? "#88E9F9" : "#085D6B"}` }}></div>
                <img className="srcImage" src={image} alt="About Us" width={width} height={height} />
                <SvgIcon color={!lightMode ? "#88E9F9" : "#085D6B"} />
                <div className='border2' style={{ borderBottom: `2px solid ${!lightMode ? "#88E9F9" : "#085D6B"}`, borderRight: `2px solid ${!lightMode ? "#88E9F9" : "#085D6B"}` }}></div>
            </div>
        </div>
    );
}

const BackButton = ({ name = "" }) => {
    const paths = ["mainService", "catalog", "viewgallery","blogpage"];
    var pathName = window.location.pathname;
    var pathExists = paths.includes(pathName.split("/")[1]);
    return <>{
        pathExists && <div className="_back" onClick={() => window.history.back()}><IoArrowBackOutline />&nbsp;&nbsp;{name}</div>
    }</>
}

const Heading = ({ lightMode = false, heading = "", subclass = "" }) => <h2 className={!lightMode ? `text-center mt-4 mb-4 headDark ${subclass} _heading` : `text-center mt-4 mb-4 headLight ${subclass} _heading`}>{heading}</h2>

function ContentCards(subService: SubServices) {
    const navigate = useNavigate();
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    return (
        <div className="photoContent">
            <div style={subService.reverse ? { flexDirection: 'row-reverse' } : {}} className={lightMode ? 'frame' : 'frame mdark'}>
                <PhotoFrame image={subService.image} />
                <div style={subService.reverse ? { marginRight: '50px', marginLeft: '0px' } : {}} className='para'>
                    <Heading lightMode={lightMode} heading={subService.heading} subclass={lightMode ? 'headLight' : 'headLDark'} />
                    <div className="contents" dangerouslySetInnerHTML={{ __html: subService.content }}></div>
                    <img className='mobImage' src={subService.image} alt='logo' />
                    {subService.navigate && <div className={`button ${lightMode ? 'Bwhite' : 'Bdark'}`} onClick={() => navigate(subService.navigate || '/')}>View More</div>}
                </div>
            </div>
        </div>
    );
}

function FlippingCards(blog: any) {
    const navigate = useNavigate();
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    var para = blog?.pars[0].content.replace(/<\/?p>/g, '');
    function nav() {
        localStorage.setItem('blogIndex', blog.id.toString());
        navigate("/blogpage");
    }
    return (
        <div className="flippingCard">
            <div className={`flipcard ${lightMode ? "lightShadow" : "darkShadow"}`}>
                <div className={`back ${!lightMode ? "cardDark" : "cardLight"}`}>
                    <h4>{blog.heading}</h4>
                    <span className="headers">{para}</span>
                    <div className="button" onClick={() => nav()}>Read More</div>
                </div>
                <div className="front">
                    <img src={blog.image !== '' ? blog.image : allImages.cargo} alt="logo" />
                    <span className="para text-center">{blog.heading}</span>
                </div>
            </div>
        </div>
    );
}
type FlippingContentCardsProps = {
    subServices: SubServices;
    button?: () => void;
    equipment?: boolean;
};
function FlippingContentCards({ subServices, button, equipment }: FlippingContentCardsProps) {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    return (
        <div className="cflippingCard">
            <div className="flipcard">
                <div className={`back ${!lightMode ? "cardDark" : "cardLight"}`}>
                    <div>
                        <center><h4 className="mb-3">{subServices.heading}</h4></center>
                        <span className={subServices.heading === "Over Dimensional Cargo" ? "nom" : ''} dangerouslySetInnerHTML={{ __html: subServices.content }}></span>
                    </div>
                    {equipment === true ? <div className="arrow"><TbArrowBigDownLinesFilled color="#085D6B" size={50} /></div> : <span />}
                    {button && <div className="button" onClick={button}>See More</div>}
                </div>
                <div className="front">
                    <img src={subServices.image} alt="logo" />
                    <span className="para text-center"><h3>{subServices.heading}</h3></span>
                </div>
            </div>
        </div>
    );
}

function Counter({ val = 0, icon = "" }) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            if (count < val) setCount(count + 1);
        }, 10)

        return () => clearInterval(interval);
    }, [count, val])
    return <div className="number">{count}{icon}</div>
}

function FiveStarRating({ size = 30 }) {
    return <div className="ratikng">
        <MdStar color="#fbbc04" size={size} />
        <MdStar color="#fbbc04" size={size} />
        <MdStar color="#fbbc04" size={size} />
        <MdStar color="#fbbc04" size={size} />
        <MdStar color="#fbbc04" size={size} />
    </div>
}


export { BackButton, PhotoFrame, Heading, ContentCards, links, FlippingCards, FlippingContentCards, Counter, FiveStarRating };